export default __webpack_public_path__ + "static/media/Orchestrait.7dadc248.svg";